import NumberHelper from "./NumberHelper";

export default class CorrectionLevelHelper {
  static VARIANT_1_STATUSES = new Set([
    "uptrend_continuation",
    "downtrend_negation",
    "uptrend_confirmation",
    "uptrend_return"
  ]);

  static VARIANT_2_STATUSES = new Set([
    "downtrend_continuation",
    "uptrend_negation",
    "downtrend_confirmation",
    "downtrend_return"
  ]);

  static calculate({ trendStatus, currentPrice, lastHigh, lastLow }) {
    const current = Number(currentPrice);
    const high = Number(lastHigh);
    const low = Number(lastLow);
    const range = high - low;

    if (
      !trendStatus ||
      !Number.isFinite(current) ||
      !Number.isFinite(high) ||
      !Number.isFinite(low) ||
      range === 0
    ) {
      return null;
    }

    let correction;

    if (CorrectionLevelHelper.VARIANT_1_STATUSES.has(trendStatus)) {
      correction = (high - current) / range;
    } else if (CorrectionLevelHelper.VARIANT_2_STATUSES.has(trendStatus)) {
      correction = (current - low) / range;
    } else {
      return null;
    }

    return Math.max(0, correction * 100);
  }

  static calculateFromRow(row) {
    if (!row) {
      return null;
    }

    return CorrectionLevelHelper.calculate({
      trendStatus: row.trend_status,
      currentPrice: row.current_price,
      lastHigh: row.last_high,
      lastLow: row.last_low
    });
  }

  static render(resultMetaData) {
    const percent = CorrectionLevelHelper.calculateFromRow(resultMetaData);

    if (percent === null) {
      return null;
    }

    return `${NumberHelper.transformFloatingValue(percent, 2, true)}%`;
  }
}
